<template>
    <div class="modal fade dialogbox " data-backdrop="static" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ title }}</h5>
                </div>
                <div class="modal-body">
                    <slot></slot>
                </div>
                <div class="modal-footer">
                    <div class="btn-inline">
                        <button class="btn btn-text-secondary" :disabled="loading" data-dismiss="modal"> Batal</button>
                        <button class="btn btn-text-primary" v-if="loading == false" :disabled="loading" @click="$emit('confirm')"> Ya</button>
                        <button class="btn btn-text-primary" v-else :disabled="loading">
                            <div class="spinner-grow text-primary" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>  
    <!-- <div v-if="show">
        <div class="modal dialogbox show" data-backdrop="static" tabindex="-1" role="dialog" :style="'display:block;'">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ title }}</h5>
                    </div>
                    <div class="modal-body">
                        <slot></slot>
                    </div>
                    <div class="modal-footer">
                        <div class="btn-inline">
                            <button class="btn btn-text-secondary" @click="$emit('close')"> Batal</button>
                            <button class="btn btn-text-primary" @click="$emit('confirm')"> Ya</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>   
        <div class="modal-backdrop fade show"></div>   
    </div> -->
</template>
<script>
export default {
    name: 'Dialog',
    props: {
        title:{
            type: String,
            required: true,
        },
        loading: {
            type: Boolean,
            required : false,
            default: false
        }
    },
}
</script>